export const homePage = {
    homePage: '首页',
    FoxitHD: '福昕·家装',
    officialPublicWx: '官方公众号',
    solution: '解决方案',
    product: '产品',
    productionService: '产品与服务',
    businessCooperation: '招商合作',
    businessCooperations: '商务合作',
    merchantsEnter: '商家入驻',
    intelligentDesignComputerEnd: '智能设计·电脑端',
    intelligentDesignDesktop: '智能设计·桌面端',
    intelligentDesignMobileTerminal: '福昕智装·移动端',
    cloudServicePremiumVersion: '云服务·尊享版',
    cloudServicesEnterpriseEdition: '云服务·企业版',
    commercialRealEstate: '公装·商业地产',
    integrationMarketingDesign: '营销设计一体化',
    learnMore: '了解更多',
    cloudServicePremiumVersionTip: '为品质家装提供个性化的项目管理服务',
    tryDesktop: '试用桌面端',
    HomeDecorationToPublicDecoration: '从家装到公装',
    HomeDecorationToPublicDecorationTip: '一站式解决方案，助力企业升级',
    commercialRealEstateTip:
        '串联<span class="tip-box">招商</span><span class="tip-box">工程</span><span class="tip-box">物业</span> 等部门，图纸审核全流程覆盖。云服务平台支持多人在线图纸协作、施工进度计划协作，全流程无纸化办公，助力企业降本增效',
    integrationMarketingDesignTip:
        '移动端赋能店长&导购、渠道销售，降低获客成本；桌面端赋能专业设计师，大屏高效设计。双端齐下，提升终端门店科技感互动体验',
    commercialRealEstateMobileTip:
        '移动端赋能店长&导购、渠道销售，降低获客成本；桌面端赋能专业设计师，大屏高效设计。双端齐下，提升终端门店科技感互动体验',
    aboutFoxit: '关于福昕',
    aboutText:
        '福建福昕软件开发股份有限公司是一家国际化运营的PDF电子文档解决方案提供厂商，是国际PDF协会主要成员、中国版式文档OFD标准制定成员。福昕在亚洲、美洲、欧洲和澳洲设有多家子公司，福昕直接用户已超过<span class="big-text">7.5</span>亿，企业客户数达<span class="big-text">42.5</span>万以上，遍及世界<span class="big-text">200</span>多个国家和地区。',
    aboutTextString:
        '福建福昕软件开发股份有限公司是一家国际化运营的PDF电子文档解决方案提供厂商，是国际PDF协会主要成员、中国版式文档OFD标准制定成员。福昕在亚洲、美洲、欧洲和澳洲设有多家子公司，福昕直接用户已超过7.5亿，企业客户数达42.5万以上，遍及世界200多个国家和地区。',
    contentFirstTitle: '国际PDF协会主要成员',
    contentFirstText:
        '主要成员中唯一一家中国公司。多年来参与了多项国际标准的制定、维护和实现工作。',
    contentSecondTitle: '中国建筑装饰协会会员',
    contentSecondText:
        '福昕家装秉承生态共享，在资源、产品、技术合作等领域实现深度融合，助力建筑装饰行业快速发展。',
    contentThirdTitle: '中国版式文档OFD标准制定成员',
    contentThirdText:
        '参与PDF国际标准、国家标准制定，是中国唯一一家双重支持国际、国内标准的版式电子文档软件厂商。',
    cloudServicePremiumListTitle: '解决传统家装业主6大不满',
    cloudServicePremiumListFirstText: '跟进体验差',
    cloudServicePremiumListSecondText: '跟踪耗时长',
    cloudServicePremiumListThirdText: '多方协作难',
    cloudServicePremiumListFourthText: '工期常超时',
    cloudServicePremiumListFifthText: '新材料问题多',
    cloudServicePremiumListSixthText: '严重超预算',
    licenseKey:
        '许可证号：闽ICP备13015634号<br/>2021 福建福昕软件开发股份有限公司 版权所有',
    assembledCeiling: '装配式吊顶',
    assembledCeilingTip: '一种天花造型，无惧顶面变化，都能灵活适配',
};
